export const creatokenPosterUrlResolver = (variantId: number) => {
    switch (variantId) {
        case 361: {
            return 'https://images.creatokia.com/technical/creatoken/0.jpg';
        }
        case 360: {
            return 'https://images.creatokia.com/technical/creatoken/1.jpg';
        }
        case 359: {
            return 'https://images.creatokia.com/technical/creatoken/2.jpg';
        }
        case 358: {
            return 'https://images.creatokia.com/technical/creatoken/3.jpg';
        }
        case 357: {
            return 'https://images.creatokia.com/technical/creatoken/4.jpg';
        }
        case 356: {
            return 'https://images.creatokia.com/technical/creatoken/5.jpg';
        }
        default: {
            return '';
        }
    }
};
